import script from "./AboutBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AboutBanner.vue?vue&type=style&index=0&id=ec2e61ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec2e61ae"]])

export default __exports__